import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface DeleteProvidedDocumentProps {
  declarationId: string;
  documentId: string;
}

export const useDeleteProvidedDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarationId, documentId }: DeleteProvidedDocumentProps) => {
      const { data } = await request(
        {
          path: `declarations/${declarationId}/provided-documents/${documentId}`,
          method: 'DELETE',
          authenticate: true,
        },
        true,
      );

      return data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declarationId] });
    },
    onError: (error) => {
      showErrorToast(error, 'Error deleting document!');
    },
  });
};
